export enum IkeLogStreamType {
	CONSOLE = 'stream-console',
	LOG_ENTRIES = 'stream-logentries',
	LOG_ENTRIES_POST = 'stream-logentries-post',
}
